import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    // Solo para recuperarse de un 400 al aceptar (cambió la versión
    // vigente): recarga la sesión, que trae los pendientes al día.
    async loadPendingLegalDocuments({ commit, dispatch }) {
        try {
            const data = await dispatch("auth/getProfile", null, {
                root: true
            });
            return data.pendingLegalDocuments || [];
        } catch (error) {
            commit("SET_ERROR_LEGAL", error);
            throw error;
        }
    },

    async acceptLegalDocuments({ commit, dispatch }, { documents }) {
        try {
            const { data } = await Http.instance.post("/bo/legal/acceptances", {
                documents
            });
            commit(
                "auth/SET_PENDING_LEGAL_DOCUMENTS",
                data.pendingLegalDocuments,
                {
                    root: true
                }
            );
            return data.pendingLegalDocuments || [];
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LEGAL", parseError);
            throw parseError;
        }
    }
};

export default actions;
